<template>
  <div class="jd-section jd-section--requirements">
    <p class="job-section__header">{{ $t('jobDetail.requirement') }}</p>
    <div v-if="hasRequirements" class="job-requirements">
      <job-requirement v-if="hasEducation" type="education" :items="[education]" />
      <template v-if="hasSkills">
        <span class="job-requirements__break section-break" />
        <job-requirement type="skill" :items="skills" />
      </template>
      <template v-if="hasCerts">
        <span class="job-requirements__break section-break" />
        <job-requirement type="cert" :items="certs" />
      </template>
      <template v-if="hasLanguageSkills">
        <span class="job-requirements__break section-break" />
        <div class="job-requirement job-requirement--language">
          <h4>{{ $t('jobDetail.languages') }}</h4>
          <div class="jd-section__items">
            <job-lang-skills
              v-if="hasSpokenSkills"
              class="jd-section__item jd-section__item--fixed-width"
              type="spoken"
              :skills="spokenSkills"
            />
            <job-lang-skills
              v-if="hasWrittenSkills"
              class="jd-section__item jd-section__item--fixed-width"
              type="written"
              :skills="writtenSkills"
            />
          </div>
        </div>
      </template>
    </div>
    <p v-else>{{ $t('general.notAvailable') }}</p>
  </div>
</template>

<script>
import JobLanguageSkills from '../jobLanguageSkill/jobLanguageSkills'
import JobRequirement from '../jobRequirement/jobRequirement'
import JobRequirementsMixin from '../../../mixins/job/requirements'

export default {
  components: {
    'job-lang-skills': JobLanguageSkills,
    'job-requirement': JobRequirement,
  },
  computed: {
    hasCerts() {
      return this.certs.length > 0
    },
    hasEducation() {
      return !!this.education
    },
    hasLanguageSkills() {
      return this.hasSpokenSkills || this.hasWrittenSkills
    },
    hasRequirements() {
      return this.hasEducation || this.hasSkills || this.hasCerts || this.hasLanguageSkills
    },
    hasSkills() {
      return this.skills.length > 0
    },
    hasSpokenSkills() {
      return this.spokenSkills.length > 0
    },
    hasWrittenSkills() {
      return this.writtenSkills.length > 0
    },
  },
  mixins: [JobRequirementsMixin],
}
</script>

<style lang="postcss">
.job-requirements__break {
  @apply mt-2 mb-0;
  &:first-child {
    /* Hide section break when there's nothing before it */
    @apply hidden;
  }
}

.job-requirement {
  & h4 {
    @apply font-medium text-sm;
    padding: 0.75em 0;
  }
  & .job-requirement__icon {
    @apply flex-shrink-0 w-8 h-8 -ml-1 mr-5 text-grey-400;
  }
}

@screen desktop {
  .job-requirements__break {
    @apply mt-4 mb-1;
  }
  .job-requirement h4 {
    @apply text-17/4;
  }
}
</style>
